import axios from "../axiosInstance";

const smsAPI = {
  getSmsGateways: () => axios.get("notifications/sms/settings"),
  
  createSmsProvider: (payload) => axios.post("notifications/sms/settings/providers", payload),
  
  updateSmsProvider: (id, payload) => axios.patch(`notifications/sms/settings/providers/${id}`, payload),
  
  deleteSmsProvider: (id) => axios.delete(`notifications/sms/settings/providers/${id}`),

  defaultSmsProvider: (id) => axios.patch(`notifications/sms/settings/providers/${id}/default`),

  getSmsTemplates: () => axios.get("notifications/sms/templates"),

  addSmsTemplates: (payload) => axios.post("notifications/sms/templates", payload),
};

export default smsAPI;
